import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Button } from '@mui/material'
import styled from 'styled-components'
import ReactToPrint from 'react-to-print'

export const MediaNoPrintWrapper = styled.div`
  @media print {
    * {
      display: none !important;
    }
  }
`

export const CustomSizePaper = styled.div`
  * {
    font-family: Arial, Helvetica, sans-serif !important;
  }
  .printOnly {
    display: none;
  }
  @media print {
    * {
      color: rgba(0, 0, 0, 1);
    }
    .printOnly {
      display: block;
    }
    .pagebreak {
      page-break-before: always;
    }
  }
`

export const ActionButtons = ({ refDialog, refPrintButton, onCloseDialog, onAfterPrint }) => (
  <MediaNoPrintWrapper>
    <Button
      variant="contained"
      size="large"
      color="error"
      onClick={onCloseDialog}
      style={{ marginRight: 10, marginLeft: 16 }}
    >
      Cancel
    </Button>

    <ReactToPrint
      trigger={() => (
        <Button ref={refPrintButton} variant="contained" size="large">
          Print
        </Button>
      )}
      onAfterPrint={() => {
        onAfterPrint()
        onCloseDialog()
      }}
      content={() => refDialog.current}
    />
  </MediaNoPrintWrapper>
)

ActionButtons.propTypes = {
  refDialog: PropTypes.object.isRequired,
  refPrintButton: PropTypes.object.isRequired,
  onCloseDialog: PropTypes.func.isRequired,
  onAfterPrint: PropTypes.func,
}

ActionButtons.defaultProps = {
  onAfterPrint: () => {},
}

export const ContainerGrid = ({ children, ...restProps }) => (
  <Grid px={2} container alignItems="center" justifyContent="space-between" {...restProps}>
    {children}
  </Grid>
)

ContainerGrid.propTypes = {
  children: PropTypes.node.isRequired,
}
